<template>
  <div v-click-outside="onClickOutside">
    <base-text-field v-model="query" @focus="didFocus" class="w-full tw-px-0" placeholder="Search for a member" size="sm" :label="label">
      <template #prefix>
        <search-icon class="tw-h-5 tw-w-5" />
      </template>
    </base-text-field>
    <transition
      enter-active-class="tw-transtion tw-ease-out tw-duration-200"
      enter-class="tw-opacity-0 tw--translate-y-1"
      enter-to-class="tw-opacity-100 tw-translate-y-0"
      leave-active-class="tw-transtion tw-ease-in tw-duration-150"
      leave-class="tw-opacity-100 tw--translate-y-0"
      leave-to-class="tw-opacity-0 tw-translate-y-1"
    >
      <div
        class="tw-absolute tw-mt-0.5 tw-z-50 tw-w-full tw-inset-x-0 tw-transform tw-shadow-lg tw-bg-white tw-rounded sm:tw-left-5 lg:tw-max-w-6xl lg:tw-mx-auto lg:tw-left-7"
        v-show="showDropdown && !isLoading"
      >
        <div v-if="customers.length">
          <div
            v-for="customer in customers"
            :key="customer.userId"
            class="tw-px-4 tw-py-2.5 hover:tw-bg-gray-100 tw-transition-colors tw-duration-100 tw-cursor-pointer"
            @click="memberSelected(customer)"
          >
            <div>{{ customer.fullName }}</div>
            <div class="tw-flex tw-flex-row">
              <div class="tw-text-xs tw-text-gray-500 tw--mt-1">{{ customer.email }}</div>
              <base-phone-number-field class="tw-text-xs tw-text-gray-500 tw--mt-1 tw-ml-2" :value="customer.phone" :isHyperlinkActive="false" />
            </div>
          </div>
        </div>
        <div class="tw-flex tw-justify-center tw-text-gray-500 tw-p-4" v-else>
          No results
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import debounce from "debounce";
import vClickOutside from "v-click-outside";
import { SearchIcon } from "@/assets/svgs";

export default {
  components: { SearchIcon },
  name: "MemberSearch",
  props: {
    businessId: String,
    label: String,
  },
  data() {
    return {
      query: "",
      showDropdown: false,
      isLoading: false,
      customers: [],
    };
  },
  watch: {
    query() {
      if (this.query.length > 0) {
        this.customers = [];
        this.isLoading = true;
        this.showDropdown = true;
        this.searchMembers();
      } else {
        this.showDropdown = false;
      }
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  methods: {
    searchMembers() {
      const search = debounce(this.getMembers, 680);
      search();
    },
    getMembers() {
      this.$axios
        .get(`/businesses/${this.businessId}/members/?skip=0&take=10&query=${encodeURIComponent(this.query)}`)
        .then((res) => {
          this.isLoading = false;
          const { items = [] } = res.data;
          this.customers = items;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    memberSelected: function(member) {
      this.$emit("memberSelected", member);
      this.showDropdown = false;
      this.query = "";
    },
    onClickOutside() {
      this.showDropdown = false;
    },
    didFocus() {
      if (this.query) {
        this.showDropdown = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/vars.scss";

#MemberSearchDropdown {
  position: absolute;
  top: 40px;
}

.spinner {
  min-width: 100px;
}
</style>
